import {
    JsonApiModel,
    Attribute,
    BelongsTo,
    JsonApiModelConfig
} from 'angular2-jsonapi'

import { TipoDeConfiguracao } from './tipo-de-configuracao.model'

@JsonApiModelConfig({
    type: 'configuracoes'
})
export class Configuracao extends JsonApiModel {
    @Attribute() valor: string
    @Attribute() idDoUsuario: number

    @BelongsTo() chave: TipoDeConfiguracao

    getValor<T>() {
        return JSON.parse(this.valor) as T
    }

    setValor(valor: any) {
        this.valor = JSON.stringify(valor)
    }
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/core/configuracao/configuracao.model.ts